import { render, staticRenderFns } from "./BoardWriteComponent.vue?vue&type=template&id=480deb7e&scoped=true"
import script from "./BoardWriteComponent.vue?vue&type=script&lang=js"
export * from "./BoardWriteComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480deb7e",
  null
  
)

export default component.exports